import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { useTheme } from 'foundations-theming-specialty/utils';
import { isTrellisTheme } from 'foundations-theming/utils';
import { OverlappingIconsButton } from './OverlappingIconsButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const SourcesButton = ({
  count = 0,
  icons = [],
  onClick,
  selected = false
}) => {
  const theme = useTheme();
  if (count === 0) {
    return null;
  }
  const isTrellis = isTrellisTheme(theme);
  return /*#__PURE__*/_jsx(OverlappingIconsButton, {
    icons: icons,
    onClick: onClick,
    selected: selected,
    backgroundColor: "fill-secondary-default",
    hoverBackgroundColor: isTrellis ? 'fill-secondary-hover' : 'fill-tertiary-hover',
    selectedBackgroundColor: isTrellis ? 'fill-secondary-pressed' : 'fill-tertiary-pressed',
    children: /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiComponentsUiLibrary.components.sourcesButton",
        options: {
          count
        }
      })
    })
  });
};
SourcesButton.displayName = 'SourcesButton';